import { mapFirstImage } from '../DataTypes/imageMapper';
import { mapBasePageProperties } from './basePagePropertiesMapper';
import logger from '3-foundation/Logging/logger';

interface Props extends Umbraco.BasePage {
	organisation: Umbraco.Organisation[];
}

export const mapOrganisationPageProperties = async (
	{ organisation, ...properties }: Props,
	pageId: string,
	siteId: string,
	locale: string,
): Promise<Content.OrganisationPageProperties> => {
	const { logo, description, address, email, phone, openingHours, organisationPageLink } = organisation?.[0]?.properties ?? {};
	const { name: linkName, route } = organisationPageLink?.[0] ?? {};
	try {
		if (!organisation.length) throw new Error('Organisation missing');
		return {
			...(await mapBasePageProperties(properties, siteId, locale)),
			organisation: {
				name: organisation?.[0]?.name,
				logo: mapFirstImage(logo),
				description: description?.markup || null,
				address: address?.markup,
				email,
				phone,
				openingHours: openingHours?.markup || null,
				organisationPageLink: route?.path ? { url: route?.path, name: linkName } : null,
			},
		};
	} catch (e) {
		logger.error(`Could not map OrganisationPage Properties \nCause: ${e}`, e);
		throw new Error(`Could not map OrganisationPage Properties \nCause: ${e}`, e);
	}
};
